import { useCallback, useState } from "react";

import { showErrorToast, showSuccessToast } from "../../components/Toast";
import { getApiErrorMessage } from "../../lib/api/apiError";

const useAddToCart = ({ cart }) => {
  const [busyAction, setBusyAction] = useState(null);

  const write = useCallback(
    async ({ items, action, replace, mode }) => {
      setBusyAction(action);

      try {
        const result = await cart.addItems(items, { replace, mode });

        if (result.status === "added") {
          if (action === "add") showSuccessToast("Added to your cart");
          if (action === "update") showSuccessToast("Your cart was updated");

          return result;
        }

        if (result.status === "error") {
          showErrorToast(
            getApiErrorMessage(result.error, "Could not update your cart. Please try again.")
          );
        }

        return result;
      } finally {
        setBusyAction(null);
      }
    },
    [cart]
  );

  const addToCart = useCallback(
    async ({ items, action = "add", notice, supplierName, mode }) => {
      if (notice) {
        showErrorToast(notice.message, supplierName);

        return { status: "blocked" };
      }

      if (!cart.enabled) {
        showErrorToast("Sign in to add items to your cart.");

        return { status: "unauthenticated" };
      }

      return write({ items, action, replace: false, mode });
    },
    [cart.enabled, write]
  );

  return { busyAction, addToCart, conflictDialog: null };
};

export default useAddToCart;
